import { getProductPending, getProductSuccess, getProductFail, 
    deleteProductPending, deleteProductSuccess, deleteProductFail,
    getSProductPending, getSProductSuccess, getSProductFail, 
    createProductPending, createProductSuccess, createProductFail, 
    modifyProductPending, modifyProductSuccess, modifyProductFail,reset,imageUploadSuccess,imageUploadFailure ,getSProductImagePending,getSProductImageSuccess,getSProductImageFail,modifyProductImagePending,modifyProductImageSuccess,modifyProductImageFail,getProductImagePending,getProductImageSuccess,getProductImageFail,deleteProductImagePending,deleteProductImageSuccess,deleteProductImageFail} from "./productSlice";
import { fetchAllProduct,fetchAllProductImage, productDelete, productImageDelete , productCreation, productModify, fetchSingleProduct, fetchSingleProductImage,productImageModify } from "../../../api/userApi";
import Swal from "sweetalert2";
export const getAllProduct = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getProductPending());
        const result = await fetchAllProduct();
        console.log("prodddd",result)
        //const userData=JSON.parse(result);
        const myJSON = JSON.stringify(result);

       // console.log('allProductData ' + myJSON);
        //console.log('alluserData 1  '+myJSON.user);
        const myObj = JSON.parse(myJSON);
        const productdetails = JSON.parse(JSON.stringify(myObj.excursionproducts));
        const productdetails1 = JSON.parse(JSON.stringify(productdetails));
      // console.log('Productdetails ' + productdetails);
       //console.log( productdetails);
        if (productdetails) {
        
            return dispatch(getProductSuccess(productdetails));
        }
        dispatch(getProductFail("Product is not found"));


    } catch (error) {
       //console.log(error.msg);
        const err = JSON.parse(JSON.stringify(error));
        // console.log(err.message);
         //console.log(JSON.parse(JSON.stringify(error)));
         dispatch(getProductFail(err.msg));

    }
}

export const getAllProductImage = () => async (dispatch) => {
    try {
        //call the api
        dispatch(getProductImagePending());
        const result = await fetchAllProductImage();
        console.log("prodddssssd",result)
        //const userData=JSON.parse(result);
        const myJSON = JSON.stringify(result);

       // console.log('allProductData ' + myJSON);
        //console.log('alluserData 1  '+myJSON.user);
        const myObj = JSON.parse(myJSON);
        const productdetails = JSON.parse(JSON.stringify(myObj.product));
        const productdetails1 = JSON.parse(JSON.stringify(productdetails));
      // console.log('Productdetails ' + productdetails);
       //console.log( productdetails);
        if (productdetails) {
        
            return dispatch(getProductImageSuccess(productdetails));
        }
        dispatch(getProductImageFail("Product image is not found"));


    } catch (error) {
       //console.log(error.msg);
        const err = JSON.parse(JSON.stringify(error));
        // console.log(err.message);
         //console.log(JSON.parse(JSON.stringify(error)));
         dispatch(getProductFail(err.msg));

    }
}

export const productDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteProductPending());
        const result = await productDelete(frmDt);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(deleteProductSuccess("Product deleted"))
        : dispatch(deleteProductFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(deleteProductFail(err.msg));
    }
    
}


export const productImageDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteProductImagePending());
        const result = await productImageDelete(frmDt);
       // console.log("userCreation "+result);
      // console.log("try block");
       //console.log(result.status);
        result.status ==="success" 
        ? dispatch(deleteProductImageSuccess("Product Image deleted"))
        : dispatch(deleteProductImageFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
       const err = JSON.parse(JSON.stringify(error.response.data.error));
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(deleteProductImageFail(err.msg));
    }
    
}

export const newProductCreation = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(createProductPending());
        const result = await productCreation(frmDt);

        //console.log(result.status==="fail");
        result.status === "success"
            ? dispatch(createProductSuccess(result.result.id))
            : dispatch(createProductFail(result.message));

           // console.log("CountryCreation "+result);
            // console.log("try block");
           // console.log(result.status);
           // console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        console.log(error);
        //  if(error.response.status===401){}
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        console.log(err);
        // console.log('disp');
        Swal.fire(err.msg,err.value,'error')
        // console.log(err.msg);
        
       
       const row = err.map((er, i) => {
        //console.log('loop');
        //console.log(er.msg);
        //console.log('loop param');

        //console.log(er.param);
            if (i === er.length - 1) {
              return er.param+' '+er.msg+'. ';
            }
            return er.param+' '+er.msg+'\n ';
          });
          //console.log('row');
          //console.log(row);
         
          dispatch(createProductFail(row));
          
        //console.log(error.response.data.error.msg);
         //console.log('catch block'+err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
       
       
       
    }

}

export const getSingleProduct = (id) => async (dispatch) => {
    
 
 console.log('service id : '+id);
    try {
     //call the api
    dispatch(getSProductPending());
    const result = await fetchSingleProduct(id);
   // const userData=JSON.parse(result.user);
 console.log('moshiiii ');
 //console.log(result);
 console.log("122",result);
 
 //console.log('check user profile out if');
    if(result.excursionproducts[0] && result.excursionproducts[0].id){
    //console.log('check user profile');
        return dispatch(getSProductSuccess(result.excursionproducts[0]));
    }
    dispatch(getSProductFail("Product is not found"));
 
   
 } catch (error) {
    // console.log("catch block");
    const err = JSON.parse(JSON.stringify(error.response.data.error));
    //console.log(error);
    console.log(err.msg);
    dispatch(getSProductFail(err.msg));
 
 }
    
 
 }



export const getSingleProductImage = (id) => async (dispatch) => {
    
 
    console.log('serviceeee id : '+id);
       try {
        //call the api
       dispatch(getSProductImagePending());
       const result = await fetchSingleProductImage(id);
       console.log("resttttt",result)

       const myJSON = JSON.stringify(result);

        const myObj = JSON.parse(myJSON);
        const productdetails = JSON.parse(JSON.stringify(myObj.product));

       if(productdetails){
  
           return dispatch(getSProductImageSuccess(productdetails));
       }
       dispatch(getSProductImageFail("Product Image is not found"));
    
      
    } catch (error) {

       const err = JSON.parse(JSON.stringify(error.response.data.error));

       console.log(err.msg);
       dispatch(getSProductFail(err.msg));
    
    }
       
    
    }
   




export const productModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyProductPending());
        const result = await productModify(frmDt);
        console.log("result",result)
        result.status === "success"
            ? dispatch(modifyProductSuccess(result.message))
            : dispatch(modifyProductFail(result.message));

            Swal.fire({
                title: 'Success!',
                text: 'Basic Details Updated Successfully',
                icon: 'success',
                confirmButtonText: 'Okay'
              })

    } catch (error) {
        // console.log("catch block");
        // console.log("cattttttttt")
        

  
        const err = JSON.parse(JSON.stringify(error.response.data.error));
        Swal.fire({
            title: 'Failed!',
            text: err.msg,
            icon: 'error',
            confirmButtonText: 'Okay'
          })
     
        dispatch(modifyProductFail(err.msg));
    }

}


export const productImageModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyProductImagePending());
        const result = await productImageModify(frmDt);
        console.log("result",result)
        result.status === "success"
            ? dispatch(modifyProductImageSuccess(result.message))
            : dispatch(modifyProductImageFail(result.message));

          //  console.log("userRoleModify "+result);
            // console.log("try block");
            //console.log(result.status);
            //console.log('actions '+result.message);

    } catch (error) {
        // console.log("catch block");
        // console.log("cattttttttt")
        // Swal.fire({
        //     title: 'Error!',
        //     text: 'This Product exist with another record',
        //     icon: 'error',
        //     confirmButtonText: 'Close'
        //   })
  
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifyProductImageFail(err.msg));
    }

}


export const resetProductCreatiion = () => async (dispatch) => {
    try {

        dispatch(reset());
    }
    catch{


    }
}


export const imageuploadProcess = (msg) => async (dispatch) => {
    try {

        dispatch(imageUploadSuccess(msg));
    }
    catch{


    }
}


export const imageUploadFailureProcess = (msg) => async (dispatch) => {
    try {

        dispatch(imageUploadFailure(msg));
    }
    catch{


    }
}
